<button class="retry-button" type="button" (click)="onClick()" [title]="title">
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="red"
         stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="margin-right: 8px">
        <polyline points="23 4 23 10 17 10"></polyline>
        <polyline points="1 20 1 14 7 14"></polyline>
        <path d="M3.51 9a9 9 0 0114.13-3.36L23 10M1 14l5.36 5.36A9 9 0 0020.49 15"></path>
    </svg>
</button>
